<script setup>
import { onMounted } from "vue";
import { animateClicks } from "@utils";

onMounted(() => {
	animateClicks();
});
</script>

<template>
	<div class="relative prebook-admin-wrapper">
		<RouterView />
	</div>
</template>